module.exports = {"id":"223066","name":"Andrés Chávez","rating":"74","photo":"./data/images/photos/4/223066.png","club":{"name":"Parque Patricios","logo":"./data/images/clubs/ParquePatricios.png"},"positions":["BU","AG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AndresChavez0.json
// module id = 387
// module chunks = 0